module.exports = __webpack_public_path__ + "static/priviliges-5-92ce0e8b7cb1674013b4e75e7fbb17fa.png";